import { render, staticRenderFns } from "./actionpointsTable.vue?vue&type=template&id=62ec761e"
import script from "./actionpointsTable.vue?vue&type=script&lang=ts"
export * from "./actionpointsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports